//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {};
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    title: function () {
      return this.$store.state['send-quest-notification']?.sendQuestNotificationTitle;
    },
    message: function () {
      return this.$store.state['send-quest-notification']?.sendQuestNotificationMessage;
    },
    type: function () {
      return this.$store.state['send-quest-notification']?.sendQuestNotificationType || '';
    },
    buttonCloseLink: function () {
      return this.$store.state['send-quest-notification']?.sendQuestNotificationParams?.buttonLink || "";
    },
    buttonCloseText: function () {
      return this.$store.state['send-quest-notification']?.sendQuestNotificationParams?.buttonText || "Закрыть";
    },
    notificationImage: function () {
      // return this.$store.state['send-quest-notification']?.sendQuestNotificationImage || '~/assets/png/smile-bird/smile-bird.png';
      return '~/assets/png/smile-bird/smile-bird.png';
    },

    buttonCloseComponent: function () {
      if (this.buttonCloseLink) {
        return "nuxt-link"
      }
      return "button"
    }
  },

  methods: {

    close: function () {
      this.$store.dispatch('send-quest-notification/hideNotification', {
        title: 'Спасибо за предложение!',
        message: 'Ваше предложение взято в работу. Как только появится ответ, мы сразу сообщим вам.',
        // params: { type: 'cool' }
      })
      // this.$store.commit(
      //   "send-quest-notification/closeSendQuestNotification",
      //   {
      //     message: '',
      //     params: {
      //       type: "cool"
      //     }
      //   }
      // )
    }

  }
};
